goog.provide("shadow.js.shim.module$$mui$icons_material$CancelRounded$default");
shadow.js.shim.module$$mui$icons_material$CancelRounded$default = shadow.js.shim.module$$mui$icons_material$CancelRounded.default;
